import Path from "../Path";
import PathPlanJumpUpLeft from "../plan/PathPlanJumpUpLeft";
import PathPlanJumpUpRight from "../plan/PathPlanJumpUpRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJumpUp2Side3 extends PathTemplatePattern {
    constructor() {
        super([
            '.88E',     // ignore   o|p     o|p     end
            '888X',     // o|p      o|p     o|p     closed
            'S8..'     //  start    o|p     ignore  ignore
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 5;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 3; // end tile is 3 columns to the right of start
        const targetRow = start.getTileRow() - 2; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 5, targetCol, targetRow);  // +5: we know the end is at least 5 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUpRight(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 3; // end tile is 3 columns to the left of start
        const targetRow = start.getTileRow() - 2; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 5, targetCol, targetRow);  // +5: we know the end is at least 5 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUpLeft(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJumpUp2Side3';
    }
}